import request from '../../axios';

export const getBasketCount = async () => {
  const {data}: {data: number} = await request.get(
    `/api/v2/order/basket/count`,
  );

  return data;
};
